














import VueOptions from '@utils/VueOptions'

settings =
  name: 'FormFieldTextGrid'

  vue:
    props: ['value', 'errors', 'items', 'cols']

    data: ->
      value_: @value || {}

    methods:
      hiInputChange: ->
        @$emit 'input', @value_

export default VueOptions.vue settings
